module.exports = __webpack_public_path__ + "tables/media/Arrow 6.4276c0d5.svg";